<template>
  <el-dialog title="审核" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small">
      <el-radio v-model="radio" label="1">通过</el-radio>
      <el-radio v-model="radio" label="2">拒绝</el-radio>
      <!-- <el-input type="textarea" v-if="radio == 2" :rows="2" placeholder="请输入内容" v-model="textarea"> -->
</el-input>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import UserApi from '@/api/user.js';
  import OrderApi from '@/api/order.js';
  export default {
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '100px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        allTag: [],
        checkedTag: [],
        textarea:'',
        radio:"1",
        order_id:''
      };
    },
    props: ['open_tag', 'form'],
    created() {
      console.log(this.form)
      this.dialogVisible = this.open_tag;
      this.order_id = this.form.withdrawal_id
      // this.getData();
    },
    methods: {
      /*获取数据*/
      getData() {
        let self = this;
        UserApi.toEditTag({
            user_id: self.form.user_id
          }, true)
          .then(res => {
            self.allTag = res.data.allTag;
            self.checkedTag = res.data.userTag;
          })
          .catch(error => {});
      },
      /*添加用户*/
      onSubmit() {
        let self = this;
        self.loading = true;
          OrderApi.withdrawalAudit({
            withdrawal_id: self.order_id,
            type:this.radio
          }, true)
            .then(res => {
              self.$message({
              message: '恭喜你，修改成功',
              type: 'success'
            });
            self.dialogFormVisible(true);
            })


        // UserApi.editTag({
        //   user_id: self.form.user_id,
        //   checkedTag: self.checkedTag
        // }, true)
        //   .then(data => {
        //     self.loading = false;
        //     self.$message({
        //       message: '恭喜你，修改成功',
        //       type: 'success'
        //     });
        //     self.dialogFormVisible(true);
        //   })
        //   .catch(error => {
        //     self.loading = false;
        //   });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/received/dialog/Tag2.vue